export default __webpack_public_path__ + "static/media/AndhraPradesh_3.4acc639a.png";